import { useQuery, useQueryClient } from "@tanstack/react-query"
import { useContext, useMemo, useState } from "react"
import Formular from "./components/Formular"
import HowTo from "./components/HowTo"
import ListOfOrders from "./components/ListOfOrders"
import { OrderType } from "./types"
import { useAddOrderRequest } from "./api/services"
import { getOrdersByCustomer } from "./api/apiCalls"
import OrderDetailModal from "./components/OrderDetailModal"
import { ModalContext } from "../components/context/ModalContext"
import { Authorized } from "../auth/Authorized"
import { P } from "../auth/permissions"

export type AddTaskFormularType = {}

export default function AddTaskFormular(props: AddTaskFormularType) {
    const queryKeyOrdersByCustomer = "orderyByCustomer"
    const {
        error: errorOrders,
        data: dataOrders,
        isLoading: isLoadingOrders,
    } = useQuery({
        queryKey: [queryKeyOrdersByCustomer],
        queryFn: getOrdersByCustomer,
    })
    const displayedOrders = useMemo(() => dataOrders?.docs, [dataOrders?.docs])

    // POST new ordner
    const queryclient = useQueryClient()
    const { mutate: addOrderRequest } = useAddOrderRequest(queryclient, queryKeyOrdersByCustomer)
    const [newOrder, setnewOrder] = useState<OrderType>()
    const handleAddNewOrder = () => {
        if (newOrder) {
            addOrderRequest(newOrder)
        }
    }

    // FRONTEND LOGIC
    const [orderForDetail, setorderForDetail] = useState<OrderType>()
    const modalCon = useContext(ModalContext)

    return (
        <main className="w-full grow min-h-0 flex px-8 py-8 gap-8">
            <ListOfOrders
                orders={displayedOrders}
                openModal={(e: OrderType) => {
                    setorderForDetail(e)
                    modalCon?.trigger(0)
                }}
            />

            {/* Anfrage stellen nur mit `create orderRequest` (früher fälschlich gleich `read`) */}
            <Authorized allOf={[P.anfragen_create]}>
                <Formular newOrder={newOrder as OrderType} setnewOrder={setnewOrder} handleAddNewOrder={handleAddNewOrder} />
            </Authorized>
            <OrderDetailModal order={orderForDetail as OrderType} modalId={0} />
        </main>
    )
}
